import { render, staticRenderFns } from "./FailedOrder.vue?vue&type=template&id=8c2abdd2&scoped=true&"
import script from "./FailedOrder.vue?vue&type=script&lang=js&"
export * from "./FailedOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2abdd2",
  null
  
)

export default component.exports